import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { PeppolStatus } from '../../../services/dto/peppol-status';
import { CamPeppolStatusComponent } from '../../peppol-status/peppol-status.component';

@Component({
  host: { 'data-cid': 'grid-peppol-status-cell' },
  imports: [CamPeppolStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-billings-peppol-status [status]="this.status"></cam-billings-peppol-status>
  </div>`,
})
export class GridPeppolStatusCellComponent extends AbstractCellComponent<unknown, PeppolStatus> {
  get status() {
    return this.value ?? PeppolStatus.Unknown;
  }
}
